::slotted(uui-expansion-panel:not(:last-child)) {
  --uui-panel-border-bottom: 0;
}
